import CashbackRatesContainer from './CashbackRatesContainer';

export default CashbackRatesContainer;
